<template>
  <div class="orderList">
    <hearderCommon :text="text"></hearderCommon>
    <van-tabs v-model="active" class="ty-tabs">
      <van-tab v-for="index in tabList" :key="index.name" :title="index.name" :to="index.path"></van-tab>
    </van-tabs>
    <router-view @list="list" @Active="Active"></router-view>
    <div class="add_rem">
      <van-button type="primary" size="large" plain round color="#74B42B" @click="goCRDtList">新增补货单</van-button>
    </div>
    <div v-if="noSearchList">
      <img src="../../assets/无订单.png" alt class="noList" />
      <p class="search-p">暂无订单</p>
    </div>
  </div>
</template>

<script>
import hearderCommon from "../common/headerCommon";
export default {
  data() {
    return {
      active: 0,
      tabList: [
        { name: "待发货", path: "ReplenishmentSend" },
        { name: "待对账", path: "ReplenishmentReconciliation" },
        { name: "交易成功", path: "ReplenishmentSucceed" }
      ],
      text: "补货订单列表",
      noSearchList: false,
      orderList: []
    };
  },
  methods: {
    // 订单为空显示
    list(list) {
      this.orderList = list;
      if (list.length === 0) {
        this.noSearchList = true;
      } else {
        this.noSearchList = false;
      }
    },
    Active(Active) {
      this.active = Active;
    },
    goback() {
      this.$router.push("/my");
    },
    goCRDtList() {
      this.$router.push('/AddSendDe')
    }
  },
  components: {
    hearderCommon
  }
};
</script>

<style scoped>
.orderList {
  background: rgba(242, 242, 242, 1);
  box-sizing: border-box;
  padding: 85px 0 50px 0;
}
header {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
}
.ty-tabs {
  font-weight: 700;
  position: fixed;
  width: 100%;
  top: 40px;
  z-index: 9999;
}
.i {
  margin: 10px;
}
.noList {
  width: 100%;
  height: 100%;
  margin-top: 100px;
}
.search-p {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  text-align: center;
}
.orderList >>> .order-header {
  width: 100px !important;
}
.van-tab {
  transition: all 1s;
}
.orderList >>> .van-tabs__line {
  background-color: #74b42b !important;
}
.orderList >>> .van-tab--active {
  background-color: rgba(249, 249, 249, 1);
  border-bottom: 4px solid #74b42b !important;
  font-weight: 700;
}
.orderList >>> .van-tabs__line {
  display: none !important;
}
.add_rem{
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: rgba(237,237,237,1);;
  height: 50px;
  line-height: 50px;
}
.van-button--large{
  width: 50%;
  line-height: 70%;
  height: 70%;
  margin-left: 25%;
  background-color: rgba(237,237,237,1);
}
</style>